import { Outlet } from 'react-router';
import FrontendLayout from '@/components/layout/FrontendLayout';
import WipBanner from '@/components/layout/WipBanner';
import { usePathname } from '@/lib/navigation';
import { sectionForPathname } from '@/lib/frontends';

export function ComplyLayoutRoute() {
    // Comply is mid-build: the section the URL falls under carries `wip: true`
    // for every unfinished feature page. When it does, slot a "not complete yet"
    // banner above the page (the same flag drives the sidebar "WIP" badge). The
    // wrapper preserves the page's `h-full` flex contract whether or not the
    // banner is present, so finished pages render unchanged.
    const pathname = usePathname();
    const isWip = sectionForPathname('comply', pathname)?.wip === true;

    return (
        <FrontendLayout frontend="comply">
            <div className="flex h-full flex-col">
                {isWip && <WipBanner />}
                <div className="flex min-h-0 flex-1 flex-col">
                    <Outlet />
                </div>
            </div>
        </FrontendLayout>
    );
}
